import { Test } from '@/models/Test'

const SET_TESTS = (state, tests) => {
  state.tests = tests
}

const SET_NEW_TEST = (state, test) => {
  state.newTest = test
}

const SET_COUNTRY_ID = (state, countryId) => {
  state.countryId = countryId
}

const SET_EMPTY_TEST = (state) => {
  state.newTest = new Test({ countryId: state.countryId })
}

const SET_BREAKOUTS = (state, breakouts) => {
  state.breakouts = breakouts
}

const SET_CARRIERS = (state, carriers) => {
  state.carriers = carriers
}

const SET_TEST = (state, test) => {
  if (state.newTest !== null) {
    Object.assign(state.newTest, test)
  }
}

export default {
  SET_TESTS,
  SET_NEW_TEST,
  SET_COUNTRY_ID,
  SET_EMPTY_TEST,
  SET_BREAKOUTS,
  SET_CARRIERS,
  SET_TEST
}



// WEBPACK FOOTER //
// ./src/store/modules/tests/mutations.js